import {useCallback} from "react";
import {call} from "redux-saga/effects";
import {useSelector} from "react-redux";
import {actions, useSagaCallback, useSagaEffect} from "../store/sagas";
import {listToReactSelect} from "../utils/format";
import {apiGet, apiPost, apiPostForm, useGetRequestData, useSagaResult} from "./client";

export const useCreateFeed = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (name, description, isPublic, includeAll) {
        return yield call(apiPost, `/api/v2/action/create_feed.json`, {
            name,
            description,
            isPublic,
            includeAll
        });
    }, []))
};

export const useSavedFeeds = (loggedIn) => {
    useSagaEffect(null, useCallback(function* () {
        if (loggedIn) {
            const data = yield call(apiGet, `/api/v2/user/feeds.json`);
            yield actions.savedFeedsLoaded(data.feeds);
        }
    }, [loggedIn]));
    return useSelector((state) => loggedIn ? state.savedFeeds : null);
};

export const usePublicSavedFeeds = (feedbackCh, page) =>
    useGetRequestData(feedbackCh, `/api/v2/feeds/all.json?page=${page}`)?.feeds;

export function* getFeedDetails(feedbackCh, feedId, isCustomFeed) {
    if (!isCustomFeed) return null;
    const data = yield call(apiGet, `/api/v2/feeds/feed.json?id=${feedId}`);
    return data.feeds[0];
}

export const useFeedDetails = (feedbackCh, feedId, isCustomFeed) =>
    useSagaResult(null, useCallback(() => getFeedDetails(feedbackCh, feedId, isCustomFeed), [feedbackCh, feedId, isCustomFeed]));


export const useFeedSettings = (feedbackCh, id, setSettings) => {
    useSagaEffect(feedbackCh, useCallback(function* () {
        const url = `/api/v2/feeds/feed.json?id=${id}`;
        const data = yield call(apiGet, url);
        const settings = data.feeds[0];
        setSettings({
            name: settings.feed_name,
            description: settings.description,
            includedCommunities: listToReactSelect(settings.included_communities),
            excludedCommunities: listToReactSelect(settings.excluded_communities),
            includedTopics: settings.included_topics,
            excludedTopics: settings.excluded_topics,
            excludedKeywords: listToReactSelect(settings.excluded_keywords),
            excludedDomains: listToReactSelect(settings.excluded_domains),
            excludedUsers: listToReactSelect(settings.excluded_users),
            isPublic: settings.is_public,
            isNSFW: settings.is_nsfw,
        });
    }, []));
};

export const useSaveFeedSettings = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (feedId, settings, logo) {
        return yield call(apiPostForm, `/api/v2/feed/update.json`, {
            id: feedId,
            name: settings.name,
            description: settings.description,
            isPublic : settings.isPublic,
            logo,
        });
    }, []))
};

export const useUpdateFeedList = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (obj) {
        return yield call(apiPostForm, `/api/v2/feed/update.json`, obj);
    }, []))
};

export const useDeleteFeed = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (id) {
        yield call(apiPost, `/api/v2/feed/delete.json`, {
            id,
        });
    }, []));
};

export const useSaveFeed = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (id, state) {
        yield call(apiPost, `/api/v2/feed/save.json`, {
            id,
            state,
        });
    }, []));
};
